import { render } from "./TermsPrivacyItem.vue?vue&type=template&id=0b4a690f&scoped=true"
import script from "./TermsPrivacyItem.vue?vue&type=script&lang=js"
export * from "./TermsPrivacyItem.vue?vue&type=script&lang=js"

import "./TermsPrivacyItem.vue?vue&type=style&index=0&id=0b4a690f&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b4a690f"]])

export default __exports__